import { useAccountApplicationSelector } from 'src/hooks';
import { MFormSection, MSpinner } from 'src/lib';

import { AccountApplicationForm } from '../../AccountApplication';

export const EntityAccountInformationSection = () => {
  const { isAccountApplicationLoading } = useAccountApplicationSelector();

  if (isAccountApplicationLoading) {
    return <MSpinner />;
  }

  return (
    <MFormSection
      title='Entity Account Information'
      isEditable={false}
      isEditMode={false}
      testId='entity-account-information'>
      <AccountApplicationForm />
    </MFormSection>
  );
};
